module.exports = __webpack_public_path__ + "img/diary_image.65b7b56d.jpg";